import { render } from "./ProductSkeleton.vue?vue&type=template&id=32dde02c&scoped=true"
const script = {}

import "./ProductSkeleton.vue?vue&type=style&index=0&id=32dde02c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32dde02c"]])

export default __exports__